import React from 'react';
import { PortailEntrepriseBase } from '../components/entreprise/PortailEntrepriseBase';

export default function PortailFinanceurPage() {
  return <PortailEntrepriseBase mode="financeur" />;
}
